import React from 'react';

import './Card20.css';

const Card20 = props => {
  return (
    <div className={`card20 ${props.className}`} style={props.style}>
      {props.children}
    </div>
  );
};

export default Card20;
